"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePlaylist = exports.createPlaylist = exports.addToPlaylist = exports.removeFromPlaylist = exports.loadPlaylistTracks = exports.loadPlaylistsData = void 0;
const axios_1 = __importDefault(require("axios"));
const PlaylistsModel_1 = require("../model/PlaylistsModel");
const auth_1 = require("../api/auth");
async function loadPlaylistsData() {
    const response = await axios_1.default.get(`${window.process.env['API_SERVER_URL']}/users/${auth_1.username}/playlists`);
    const playlistsInfo = response.data;
    const playlistsData = await Promise.all(playlistsInfo.map(async (playlist) => {
        const tracks = await loadPlaylistTracks(playlist.id);
        const imageId = playlist.id % PlaylistsModel_1.PLAYLIST_IMAGES_COUNT;
        return {
            id: playlist.id,
            name: playlist.name,
            imageId,
            songs: tracks,
        };
    }));
    return playlistsData;
}
exports.loadPlaylistsData = loadPlaylistsData;
async function loadPlaylistTracks(id) {
    const response = await axios_1.default.get(`${window.process.env['API_SERVER_URL']}/playlists/${id}`);
    return response.data.songs;
}
exports.loadPlaylistTracks = loadPlaylistTracks;
async function removeFromPlaylist(playlistId, trackId) {
    await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/playlists/${playlistId}/remove/${trackId}`);
}
exports.removeFromPlaylist = removeFromPlaylist;
async function addToPlaylist(playlistId, trackId) {
    const response = await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/playlists/${playlistId}/add/${trackId}`);
    return response.data;
}
exports.addToPlaylist = addToPlaylist;
async function createPlaylist(name) {
    const response = await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/playlists`, {
        name: name,
    });
    const playlist = response.data;
    playlist.songs = [];
    return playlist;
}
exports.createPlaylist = createPlaylist;
async function deletePlaylist(playlistId) {
    await axios_1.default.delete(`${window.process.env['API_SERVER_URL']}/playlists/${playlistId}`);
}
exports.deletePlaylist = deletePlaylist;
